<template>
<div>
  <div class="container">
    <div class="row">
      <div class="col-md-3" v-for="{name, slug, component} in accomodation_components" :key="name">
        <a href="javascript:void(0)" class="menu-link text-center text-bold" :class="(slug == currentComponentSlug) ? 'active' : null" @click="selectAccomodationComponent(slug,component)">
          {{ name }}
        </a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <component :is="currentComponent" 
          :accommodation="accommodation" 
          :added_images="accommodationImages"
          @updateAccomodation="getAccommodation"
      ></component>
    </div>
  </div>

</div>

</template>

<script>

import AccomodationDetails from '../components/Accomodation/AccomodationDetails.vue'
import AccomodationTours from '../components/Accomodation/AccomodationTours.vue'
import AccomodationGallery from '../components/Accomodation/AccomodationGallery.vue'
import AccommodationRoomsEdit from './AccommodationRoomsEdit.vue'

import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'AccommodationEdit',
  components: {
    Errors,
    AccomodationDetails,
    AccommodationRoomsEdit,
    AccomodationTours,
    AccomodationGallery
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data () {
    return {
      accomodation_components : [
        {
          name:'Accomodation Details',
          slug:'accomodation_Details',
          component:'AccomodationDetails'
        },
        {
          name:'Gallery',
          slug:'gallery',
          component:'AccomodationGallery'
        },
        {
          name:'Rooms',
          slug:'rooms',
          component:'AccommodationRoomsEdit'
        },
        {
          name:'Tours',
          slug:'tours',
          component:'AccomodationTours'
        }
      ],
      currentComponentSlug: 'accomodation_Details',
      currentComponent:'AccomodationDetails',
      accommodation: null,
      errors: null,
      tourAccommodationLinked: '',
      accommodationImages:[]
    }
  },
  created () {
    this.getAccommodation()
  },
  watch: {
    '$route': 'getAccommodation'
  },
  methods: {
    getAccommodation () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'accommodation/' + this.$route.params.id, {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.accommodation = response.data[0]
        this.accommodationImages = response.data[0].gallery_image_link
      })
    },
    selectAccomodationComponent(slug, comp) {
      this.currentComponentSlug = slug
      this.currentComponent = comp
    },
    updateAccommodation () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'accommodation/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(this.accommodation),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
<style scoped>
.menu-link {
  display: block;
  height: 60px;
  padding: 15px 20px;
  border-radius: 5px;
  text-decoration: none;
  color: #000;
  background-color: #fff;
  border: 1px solid #dee2e6;
  font-size: 18px;
  font-weight: bold;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.menu-link.active {
  background-color: #fd7e14;
  color: #fff;
  border: 1px solid #fd7e14;
}
</style>
